<template>
	<section class="flex justify-center text-sm md:px-20 px-6 py-4" style="background-color: #F7F7F7;">
		<div class="w-full" style="max-width: 1366px;">
			<Breadclumb :menu="breadclumb"/>
			<h1 class="text-2xl md:text-3xl text-spc font-semibold mb-6">{{ title }}</h1>
			<div class="grid grid-rows-1 mb-9 gap-x-10 w-max max-w-full" style="grid-template-columns: max-content 1fr;">
				<svg width="48" height="48" class="w-12 h-12 place-self-center" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path fill-rule="evenodd" clip-rule="evenodd" d="M31.5 44.64H16.5L18 36H30L31.5 44.64V44.64Z" stroke="#2966F5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
					<path d="M12 44.64H36" stroke="#2966F5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
					<path d="M1.5 30.2399H46.5" stroke="#2966F5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
					<path fill-rule="evenodd" clip-rule="evenodd" d="M1.5 4.43994C1.5 2.78308 2.84315 1.43994 4.5 1.43994H43.5C45.1569 1.43994 46.5 2.78309 46.5 4.43994V32.9999C46.5 34.6568 45.1569 35.9999 43.5 35.9999H4.5C2.84315 35.9999 1.5 34.6568 1.5 32.9999V4.43994Z" stroke="#2966F5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
				</svg>
				<p class="text-base font-normal text-gray-500" style="max-width: 662px;">
					{{ description }}
				</p>
				<div class="grid gap-x-5 col-span-2 box-border md:col-span-1 md:col-start-2 mt-5 bg-white md:text-sm text-xs rounded-3xl w-full p-6" style="max-width: 782px; grid-template-columns: max-content 1fr;" v-if="warning !== undefined">
					<svg width="24" height="24" viewBox="0 0 24 24" class="row-start-1 row-end-3 place-self-center" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M12 6.49L19.53 19.5H4.47L12 6.49ZM12 2.5L1 21.5H23L12 2.5ZM13 16.5H11V18.5H13V16.5ZM13 10.5H11V14.5H13V10.5Z" fill="#2966F5"/>
					</svg>
	
						<strong class="font-semibold">ATENÇÃO:</strong>
						<p class="text-gray-600 col-start-2" v-html="warning">
					</p>
				</div>
			</div>
			<h3 class="font-semibold text-base text-gray-600 mb-9 md:text-left text-center max-w-xs md:max-w-none mx-auto md:mx-0">Escolha a forma de emissão do seu Certificado Digital.</h3>
			<ul class="flex md:flex-row flex-col gap-4 mb-7">
				<li v-for="item in cards" :key="item.title" class="li-opcao grid md:flex flex-col items-center w-full md:w-52 p-3 rounded-3xl text-center bg-white box-border">
					<img :src="item.icon"/>
					<h3 class="text-base md:text-xl text-spc font-bold md:mb-4">{{ item.title }}</h3>
					<p class="text-xs text-gray-500 mb-4 whitespace-pre-wrap">{{ item.content }}</p>
					<a :href="item.href" class="bg-spc-100 p-3 box-border w-full font-bold text-white rounded-full mt-auto mb-4">Selecionar</a>
				</li>
			</ul>
			<h2 class="text-2xl font-normal text-gray-600 mb-2">
				Conte com o suporte do SPC Brasil
			</h2>
			<div class="w-full" style="max-width: 600px;">
				<p class="text-base font-normal text-gray-500 mb-5">
					Em caso de dúvidas, acesse nossos canais de atendimento clicando em <a onclick="javascript:window.xgen.maximizeEmbed();" class="text-spc-100 cursor-pointer" target="_blank" >"Olá, Posso ajudar?"</a> 
				</p>
				<p class="text-base font-normal text-gray-500 mb-5">
					Atendimento disponível de segunda a sexta-feira, das 8h às 19h.
				</p>

				<p class="text-base font-normal text-gray-500 mb-5">
					Para facilitar o seu atendimento, <a href="https://anydesk.com/pt/downloads/thank-you?dv=win_exe" class="text-spc-100" target="_blank" >faça o download do Anydesk clicando aqui</a>. Essa ferramenta é necessária para que os nossos especialistas te auxiliem. Após a instalação, abra o Anydesk e informe o número do dispositivo, que será solicitado no atendimento.
				</p>
			</div>
		</div>
		
	</section>
</template>
<script>
import Breadclumb from "@/components/breadclumb";
	export default {
		props: {
			title: String,
			breadclumb: Array,
			description: String,
			warning: [String, undefined],
			cards: Array
		},
		methods: {
			handleClickHelpMe () {
				const el = document.getElementById("embed-minimized-title")
				console.log(el)
				el.click()
			}
		},
		components: {
			Breadclumb
		}
	}
</script>
<style>
	@media screen and (max-width: 768px) {
		li.li-opcao {
			grid-template-columns: 1fr 1fr;
			column-gap: 16px;
			justify-items: center;
			grid-template-rows: repeat(4,max-content);
		}
		li.li-opcao a {
			grid-row: 1 / 4;
			grid-column: 2/3;
			/* margin: auto 0; */
		}

	}
</style>
